module.exports = __webpack_public_path__ + "img/tax-rate-low.013541b5.svg";